import { SubNavigationBar } from '@common/components/navigation-bar';
import { EFilters } from '@modules/forms/constants';
import { t } from 'i18next';
import React from 'react';
import { FormsMeta } from '../../containers/forms/types';

interface Props {
  meta: FormsMeta;
}

const FormsSubNavigation = ({ meta }: Props) => {
  return (
    <SubNavigationBar title={t('core:tab_forms')}>
      <SubNavigationBar.Item
        exact
        icon="assignment"
        path="/admin/forms"
        title={t('common:filter_all')}
        count={meta?.counts?.total_count || 0}
      />
      <SubNavigationBar.Item
        icon="play_arrow"
        path={`/admin/forms/filter/${EFilters.LIVE}`}
        title={t('common:status_live')}
        count={meta?.counts?.live_count || 0}
      />
      <SubNavigationBar.Item
        icon="draft"
        path={`/admin/forms/filter/${EFilters.DRAFT}`}
        title={t('common:status_draft')}
        count={meta?.counts?.draft_count || 0}
      />
      <SubNavigationBar.Item
        icon="inventory"
        path={`/admin/forms/filter/${EFilters.ARCHIVED}`}
        title={t('common:status_archived')}
        count={meta?.counts?.archived_count || 0}
      />
    </SubNavigationBar>
  );
};

export default FormsSubNavigation;
